export default "__VITE_ASSET__D2Vqf5oR__"